import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import DiagramUtils from "../utils/DiagramUtils";
import ModelCssLengthProperty from "./ModelCssLengthProperty";
import ModelScriptsProperty from "./ModelScriptsProperty";
import ModelDataContextProperty from "./ModelDataContextProperty";
import ModelDataSourceProperty from "./ModelDataSourceProperty";
import ModelMessageSubscribeProperty from "./properties/ModelMessageSubscribeProperty";
import ModelEventSubscribeProperty from "./properties/ModelEventSubscribeProperty";

// import { } from "../utils/ScriptServiceSelectorEditor";
import { } from "./ModelDataSourcesEditor";
// import sm4 from '../utils/sm4/sm4';

export default class Model extends ObservablePropertyDescriptorObject {

    id = new PropertyDescriptor(`diagram-${Math.random().toString()}`, "标识", "其他", "string", "#anticon-key", {
        catalogIndex: 99,
        editable: false,
        gallery: "其他",
        galleryIndex: 99,
    });

    name = new PropertyDescriptor(``, "名称", "其他", "string", "#anticon-TrainTicket", { gallery: "其他" });
    isLock = new PropertyDescriptor(false, "锁定", "其他", "bool", "#anticon-lock-blue-a", { enabled: false, gallery: "其他", description: "锁定部件后，您将无法通过鼠标改变部件的位置和大小；但您仍然可以通过属性编辑器来设置部件的位置、大小和其他参数。" });
    isEdit = new PropertyDescriptor(false, "交互模式", "其他", "bool", "#anticon-kzt__yiji_wodequnzu", { gallery: "其他", description: "启用后，您可以与部件内部的可交互元素互动；禁用后，您将无法与其互动。（您无需手动控制该参数，双击部件即可开启互动模式，点击空白处即可关闭互动模式）" });
    allowMask = new PropertyDescriptor(true, "允许掩膜", "其他", "bool", undefined, { gallery: "其他", enabled: false });
    showFocus = new PropertyDescriptor(false, "显示焦点边框", "其他", "bool", undefined, { gallery: "其他", enabled: false });
    hidden = new PropertyDescriptor(false, "销毁", "其他", "bool", "#anticon-trash-gray1", {
        enabled: true,
        gallery: "其他",
        description: "销毁部件，让部件在整个页面中完全消失，会起到隐藏部件的效果，但同时会导致部件的脚本失效；取消销毁后部件会重建，脚本在之后开始生效"
    });
    visibility = new PropertyDescriptor(true, "可见", "其他", "bool", "#anticon-ic_eye_hide", {
        enabled: true,
        gallery: "其他",
        description: "启用后部件处于可见状态，关闭后部件隐藏，但脚本仍然处于工作状态"
    });
    flag = new PropertyDescriptor(0.0, "加载标识", "其他", "double", undefined, { enabled: false });
    // parent = new PropertyDescriptor(null, "父级", "其他", "object", undefined, { enabled: false });

    style = new PropertyDescriptor("", "扩展样式", "高级", "css", "#anticon-CSS", {
        catalogIndex: 90,
        description: "如果您觉得编辑器中的参数无法满足需求时，可以编写原生 CSS 来控制部件的外观和行为",
        enabled: false,
    });

    scripts = new PropertyDescriptor(new ModelScriptsProperty(), "脚本与样式", "高级", "object", "#anticon-Documentation", {
        catalogIndex: 90,
        gallery: "其他",
        galleryIndex: 80,
        description: "通过编写脚本来自定义部件的逻辑",
        valueTemplate: ModelScriptsProperty,
    });

    dataContext = new PropertyDescriptor(new ModelDataContextProperty(), "数据上下文", "其他", "object", "#anticon-JSON-copy", {
        gallery: "数据",
        catalogIndex: 99,
        description: "为部件设置数据上下文，然后在脚本中使用，以实现自定义逻辑",
        valueTemplate: ModelDataContextProperty,
    });

    dataSources = new PropertyDescriptor([], '数据源', "数据", "datasources", "#anticon-icon-test", {
        gallery: "数据",
        galleryIndex: 75,
        modelTemplate: ModelDataSourceProperty,
        modelCreator: (opts) => {
            const m = new ModelDataSourceProperty(opts);
            m._sys.__runScript = this.runScript.bind(this);
            m._sys.__runActions = this.runActions.bind(this);
            return m;
        },
        modelGetter: (opts) => {
            const m = new ModelDataSourceProperty(opts);
            m._sys.__runScript = this.runScript.bind(this);
            m._sys.__runActions = this.runActions.bind(this);
            m._sys.__uiReady = !this.hidden;
            return m;
        }
    });

    events = new PropertyDescriptor([], '订阅事件', "事件", "objects", "#anticon-speed", {
        gallery: "数据",
        galleryIndex: 78,
        modelTemplate: ModelEventSubscribeProperty,
        modelCreator: (opts) => {
            const m = new ModelEventSubscribeProperty(opts);
            m._sys.__designer = this._sys.designer;
            m._sys.__model = this;
            m._sys.__runActions = this.runActions.bind(this);
            return m;
        },
        modelGetter: (opts) => {
            const m = new ModelEventSubscribeProperty(opts);
            m._sys.__designer = this._sys.designer;
            m._sys.__model = this;
            m._sys.__runActions = this.runActions.bind(this);
            return m;
        }
    });

    messages = new PropertyDescriptor([], '订阅消息', "消息", "objects", "#anticon-noun_Soundwave_1786379", {
        gallery: "数据",
        modelTemplate: ModelMessageSubscribeProperty,
        modelCreator: (opts) => {
            const m = new ModelMessageSubscribeProperty(opts);
            m._sys.__designer = this._sys.designer;
            m._sys.__runActions = this.runActions.bind(this);
            // m.on();
            return m;
        },
        modelGetter: (opts) => {
            const m = new ModelMessageSubscribeProperty(opts);
            m._sys.__designer = this._sys.designer;
            m._sys.__runActions = this.runActions.bind(this);
            m.on();
            return m;
        },
        modelRemover: (m) => {
            m.off();
        },
    });

    static lengthCssValue(length) {

        if (length < 0)
            return "100%";
        if (length === 0)
            return "auto";
        if (length > 0)
            return length + "px";

        if (length instanceof ModelCssLengthProperty) {
            return length.toStyle();
        }
        else {
            return "auto";
        }
    }

    static flexCssValue(length) {

        if (length < 0)
            return "0 0 auto";
        if (length === 0)
            return "0 0 auto";

        return length + "";
    }

    getType() {
        return "Model";
    }

    toString() {
        if (this.name)
            return this.name;

        const diagrams = DiagramUtils.diagrams;
        const modelInfo = diagrams[this.getType()];
        if (modelInfo)
            return modelInfo.alias;

        return this.getType();
    }

    listenRefsPropertyChanged() {
        this.unlistenRefsPropertyChanged();

        this.dataContext.refs.forEach(c => {
            if (!c._sys.ref || !c.enabled)
                return;

            let un = c._sys.ref.registerPropertyChangedListener((name, valOld, valNew, subName, args) => {
                this.onRefPropertyValueChanged(c._sys.ref, name, valOld, valNew, subName, args);
            });

            this._sys.__refUnListeners.push(un);
        });
    }

    unlistenRefsPropertyChanged() {
        if (!this._sys.__refUnListeners)
            this._sys.__refUnListeners = []

        this._sys.__refUnListeners.forEach(c => c());
        this._sys.__refUnListeners = [];
    }

    onRefPropertyValueChanged(ref, name, valOld, valNew, subName, args) {

    }

    hasScript() {
        return this.scripts.hasScript();
    }

    hasDataContext() {
        return this.dataContext.hasDataContext();
    }

    findById(id) {
        if (this.id === id)
            return this;

        return null;
    }

    setUserData(name, data) {
        let map = this._sys.__userData__
        if (!map)
            map = this._sys.__userData__ = {};

        map[name] = data;
    }

    getUserData(name) {
        let map = this._sys.__userData__
        if (!map)
            map = this._sys.__userData__ = {};

        return map[name];
    }

    getDefaultDataSource() {
        let ds = this.dataSources.find(c => c.isDefault);
        if (!ds && this.dataSources.length)
            ds = this.dataSources[0];

        return ds;
    }

    getDataSource(name) {
        if (!name)
            return null;

        let ds = this.dataSources.find(c => c.name === name);
        return ds;
    }

    getDefaultData() {
        let ds = this.dataSources.find(c => c.isDefault);
        if (!ds && this.dataSources.length)
            ds = this.dataSources[0];

        return ds && ds.data;
    }

    getData(name) {
        const ds = this.getDataSource(name);
        return ds && ds.data;
    }

    getDefaultMetadata() {
        let ds = this.dataSources.find(c => c.isDefault);
        if (!ds && this.dataSources.length)
            ds = this.dataSources[0];

        if (!ds)
            return null;

        return {
            columns: ds.dataPreview.data.columns || [],
            data: ds.data,
        };
    }

    getMetadata(name) {
        const ds = this.getDataSource(name);
        if (!ds)
            return null;

        return {
            columns: ds.dataPreview.data.columns || [],
            data: ds.data,
        };
    }

    getDefaultDataArray() {
        const data = this.getDefaultData();
        if (data === null)
            return [];
        if (!(data instanceof Array))
            return [data];

        return data;
    }

    getDataArray(name) {
        const data = this.getData(name);
        if (data === null)
            return [];
        if (!(data instanceof Array))
            return [data];

        return data;
    }

    getDefaultMetadataArray() {
        const meta = this.getDefaultMetadata();
        if (!meta)
            return null;

        if (meta.data === null)
            meta.data = [];
        if (!(meta.data instanceof Array) && typeof meta.data !== "object")
            meta.data = { value: meta.data }
        if (!(meta.data instanceof Array))
            meta.data = [meta.data];

        if (meta.columns.length === 1 && meta.columns[0].isAtom)
            meta.data = meta.data.map(c => {
                const item = {};
                item[meta.columns[0].name] = meta.columns[0].getValue(c);
                return item;
            })

        return meta;
    }

    getMetadataArray(name) {
        const meta = this.getMetadata(name);
        if (!meta)
            return null;

        if (meta.data === null)
            meta.data = [];
        if (!(meta.data instanceof Array) && typeof meta.data !== "object")
            meta.data = { value: meta.data }
        if (!(meta.data instanceof Array))
            meta.data = [meta.data];

        if (meta.columns.length === 1 && meta.columns[0].isAtom)
            meta.data = meta.data.map(c => {
                const item = {};
                item[meta.columns[0].name] = meta.columns[0].getValue(c);
                return item;
            })

        return meta;
    }

    registerEvent(name, alias) {
        if (!this.events.values)
            this.events.values = [];

        this.events.values.push(new PropertyDescriptor(name, alias, undefined, undefined, "#anticon-speed"));
    }

    toJsonObject() {

        let o = {
            type: this.getType(),
            model: {},
        }

        for (const key in this) {
            if (!(key in this._))
                continue;

            const element = this[key];
            let v = null;
            if (element instanceof ObservablePropertyDescriptorObject)
                v = element.toJsonObject();
            else if (element instanceof Array) {
                v = element.map(c => c && c.toJsonObject && c.toJsonObject() || c);
            }
            else
                v = element;

            o.model[key] = v;
        }

        return o;
    }

    setRandomId() {
        this.id = `diagram-${Math.random().toString()}`;
    }

    setRandomIdSelf() {
        this.id = `diagram-${Math.random().toString()}`;
    }

    setRandomFlag(notify) {
        if (notify)
            this.flag = Math.random();
        else
            this._.flag._.value = Math.random();
    }

    onPropertyValueChanged(name, valOld, valNew, subName, args) {
        super.onPropertyValueChanged(name, valOld, valNew, subName, args);

        if (name === "style" && subName === undefined && valNew && this.scripts && !this.scripts.style) {
            this.scripts.style = valNew;
        }
        else if (name === "scripts" && subName === undefined && valNew && !valNew.style) {
            valNew.style = this.style;
        }
        else if (name === "dataContext.refs") {
            this.listenRefsPropertyChanged();
        }
        else if (name && name.startsWith("dataSources")) {
            const metadata = this.getDefaultMetadata();
            this.dataContext.dataPreview.data = metadata;
        }
    }

    getDataContext() {

        let m = this;
        do {
            let data = m.dataContext.data;
            if (data)
                return data;

            m = m._sys.parent;
        }
        while (m);

        return this._sys.designer.paper.getDataContext();
    }

    getInternalDataContext() {

        let m = this;
        do {
            let data = m.dataContext.data;
            if (data)
                return data;

            m = m._sys.parent;
        }
        while (m);

        return null;
    }

    getParentDataContext() {
        let m = this;
        const parent = m._sys.parent;
        if (!parent)
            return null;

        return parent.getDataContext();
    }

    expandModels() {
        return [this];
    }

    getDiagramExtendStyle() {
        return undefined;
    }

    getDiagramExtendClass() {
        return this.scripts.extendClass;
    }

    getExtendStyle() {

        try {
            let style = this.scripts.style.trim();
            style = style.substring(1, style.length);
            style = style.substring(0, style.length - 1);
            let newStyle = {};
            if (style) {
                for (let v of style.split(';')) {
                    if (!v || !v.trim())
                        continue;
                    try {
                        let index = v.indexOf(":");
                        if (index < 0)
                            continue;

                        let key = v.substring(0, index);
                        let value = v.substring(index + 1, v.length);
                        newStyle[key.replace(/-(.)/g, function (w, v) { return v.toUpperCase(); }).trim()] = value.trim();
                    }
                    catch (err) {
                        console.warn(err);
                    }
                }
            }
            return newStyle;
        }
        catch (e) {
            return {};
        }
    }

    // 实现该函数定义该控件需要加入到智能提示的对象
    codeAssist() {
        return [{}, {
            model: {
                getDataSource: this.getDataSource,
                getDefaultData: this.getDefaultData,
                getMetadata: this.getMetadata,
                getUserData: this.getUserData,
                setRandomFlag: this.setRandomFlag,
                setUserData: this.setUserData
            }
        }]
    }

    runActions(actions, data) {
        let m = this;
        const results = actions.map(c => {
            return c && c.run(data, {
                model: m,
                designer: m._sys.designer,
                runScript: this.runScript.bind(this),
            });
        });

        return results && results.length && results[results.length - 1];
    }

    runScript(script, customDataContext, customModel, args, opts) {

        if (!script)
            return;

        return DiagramUtils.runScript(this, script, customDataContext, customModel, args, opts);
    }

    restoreRefs(modelInfo) {
        this.dataContext.refs.forEach(ref => {
            if (ref.id === modelInfo.id) {
                ref.id = modelInfo.newId;
                ref._sys.ref = modelInfo.instance;
            }
        });
    }
}
